import { Fragment, useContext } from "react"
import { BaseTable, Loading, Select } from "components"
import { dataAccountLink } from "../../utils"
import { LinkAccountContext } from "pages/Setup/contexts"
import { useDepartement, useDivisi } from "pages/Card/Transaction/CreateNewEmployee/components/FormSection/utils"
import { useMarketing } from "pages/Card/Transaction/CreateNewCustomer/components/FormSection/utils"

export function ChildItem() {
  const dataMobileApproval = useContext(LinkAccountContext)

  return (
    <Fragment>
      {dataMobileApproval?.isLoading ? ( <Loading loading={dataMobileApproval?.isLoading} /> ) : (
        <div className="border">
          {dataAccountLink.map((i, key) => (
            <div key={key}>
              <div className="border p-4">
                <span className="font-bold">{i.Header}</span>
              </div>
              <div>
                <div className="p-4">
                  <BaseTable className="table">
                    <thead>
                      <tr>
                        <th className="border">CODE</th>
                        <th className="border">TRANSACTION</th>
                        <th className="border">DIVISI</th>
                        <th className="border">DEPARTMENT</th>
                        <th className="border">EMPLOYEE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {i.LinkAccount.map((item, index) => {

                        return (
                          <tr key={index}>
                            <td className="border w-[100px]">{item?.linked_account_code}</td>
                            <td className="border w-[300px]">{item?.description}</td>
                            <td className="border w-[200px]"><DropdownDivisi /></td>
                            <td className="border w-[200px]"><DropdownDepartement /></td>
                            <td className="border w-[200px]"><DropdownMarketing /></td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </BaseTable>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Fragment>
  )
}
const DropdownDivisi = () => {
  const dataDivisi = useDivisi()

  return (
    <Select
      placeholder="Select divisi..."
      controlClass="my-[-8px] mx-[-12px]"
      isLoading={dataDivisi?.isLoading}
      options={dataDivisi?.data}
    />
  )
}
const DropdownDepartement = () => {
  const dataDepartement = useDepartement()

  // useEffect(() => {
  //   refetch(divisi_id?.toString())
  //   // eslint-disable-next-line
  // }, [divisi_id])

  return (
    <Select
      placeholder="Select departement..."
      controlClass="my-[-8px] mx-[-12px]"
      // isDisabled={props.isDisabled || !divisi_id}
      isLoading={dataDepartement?.isLoadingDepartement}
      options={dataDepartement?.dataDepartement}
    />
  )
}
const DropdownMarketing = () => {
  const dataEmployee = useMarketing()

  return (
    <Select
      placeholder="Select employee..."
      controlClass="my-[-8px] mx-[-12px]"
      isLoading={dataEmployee?.isLoading}
      options={dataEmployee?.data}
    />
  )
}